import React from "react";

export default function Text({ style, children }) {
  return <span style={{ ...style }}>{children}</span>;
}
